// global
import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'semantic-ui-react';

const TableHeaderCellSort = ({ title, onClick, column, sort, style, width }) => {
    const sortCurrent = sort && sort.column === column;
    return (
        <Table.HeaderCell sorted={sortCurrent ? sort.direction : null} onClick={onClick} className={'custom-sort'} style={style} width={width}>
            {title}
        </Table.HeaderCell>
    );
};

TableHeaderCellSort.propTypes = {
    title: PropTypes.string.isRequired,
    column: PropTypes.string,
    sort: PropTypes.object,
    onClick: PropTypes.func,
    width: PropTypes.string,
    style: PropTypes.object,
};

export default TableHeaderCellSort;
